/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gdpr_Action_ListInputs */

const cs_gdpr_action_list = /** @type {(inputs: Gdpr_Action_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výpis`)
};

const en_gdpr_action_list = /** @type {(inputs: Gdpr_Action_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listed`)
};

/**
* | output |
* | --- |
* | "Listed" |
*
* @param {Gdpr_Action_ListInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const gdpr_action_list = /** @type {((inputs?: Gdpr_Action_ListInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gdpr_Action_ListInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gdpr_action_list(inputs)
	return cs_gdpr_action_list(inputs)
});